import type { MRT_VisibilityState } from "mantine-react-table-open";

export const isFirstVisibleColumn = (
  columnKey: string,
  columnVisibility: MRT_VisibilityState,
  columns: ReadonlyArray<string>
): boolean => {
  const firstVisibleIndex = columns.findIndex(
    (col) => columnVisibility[col] !== false
  );

  return columns[firstVisibleIndex] === columnKey;
};
